import { createFileRoute, Navigate } from '@tanstack/react-router';
import type { TeamView } from '@/features/attendance/TeamMonthPage';

/**
 * Atteso mensile del team — `GET /api/shift-composition?employeeIds=` (BE v1.110.0).
 *
 * La variante multi-dipendente esiste per questa vista: con la forma a singolo id servirebbe
 * una chiamata per persona, e la tabella su cento dipendenti ne farebbe cento.
 *
 * Dal 03-11-2026 è la scheda «Atteso del team» di «Presenze del personale»: l'indirizzo resta e ci
 * porta, con la vista chiesta.
 */
export const Route = createFileRoute('/_app/attendance_/team-month')({
  /* `?teamView=giorno`: ci arriva «Presenze» per chi cerca la giornata di un collega (26-10-2026).
     ⚠️ Non `view`: le chiavi di ricerca si sommano su tutte le rotte, e `/projects` ha già un
     `view` di un altro tipo. */
  validateSearch: (s: Record<string, unknown>): { teamView?: TeamView } => ({
    teamView: s.teamView === 'giorno' || s.teamView === 'settimana' ? s.teamView : undefined,
  }),
  component: TeamMonthRoute,
});

function TeamMonthRoute() {
  const { teamView } = Route.useSearch();
  return <Navigate to="/hr/presence" search={{ tab: 'expected', teamView }} replace />;
}
